import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyHowtobuyNestedComponent } from '../nested-components/nested-company-howtobuy/company-howtobuy-nested.component';
import { NestedWarningSoftwareDowngradeComponent } from '../nested-components/nested-warning-software-downgrade/nested-warning-software-downgrade.component';
import { SafePipe } from '../SafePipe';
import { NgOptimizedImage, provideImgixLoader } from '@angular/common';
import { NestedWarningSoftwareUpgradeRxt1200Component } from '../nested-components/nested-warning-software-upgrade-rxt1200/nested-warning-software-upgrade-rxt1200.component';
import { NestedWarningSoftwareUpgradeRxt4500Component } from '../nested-components/nested-warning-software-upgrade-rxt4500/nested-warning-software-upgrade-rxt4500.component';
import { NestedServerVesionComponent } from '../nested-components/nested-server-vesion/nested-server-vesion.component';
import { NestedServerVesionImageComponent } from '../nested-components/nested-server-vesion-image/nested-server-vesion-image.component';
import { FormsModule } from '@angular/forms';
import { NestedNavRelatedproductsComponent } from '../nested-nav/nested-nav-relatedproducts/nested-nav-relatedproducts.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NestedSupportNavComponent } from '../nested-nav/nested-nav-support/nested-support-nav.component';
import { NestedPrivacyPolicyComponent } from '../nested-components/nested-privacy-policy/nested-privacy-policy.component';
import { NestedTermsOfUseComponent } from '../nested-components/nested-terms-of-use/nested-terms-of-use.component';
import { ComponentVxCardComponent } from '../components/component-vx-card/component-vx-card.component';
import { ComponentLineClampComponent } from '../components/component-line-clamp/component-line-clamp.component';
import { NestedSidebarIntrocwdmDwdmOptnetPosterComponent } from '../nested-sidebar/nested-sidebar-introcwdm-dwdm-optnet-poster/nested-sidebar-introcwdm-dwdm-optnet-poster.component';
import { NestedSidebarSyncptpPosterComponent } from '../nested-sidebar/nested-sidebar-syncptp-poster/nested-sidebar-syncptp-poster.component';
import { NestedSidebarIntroponPosterComponent } from '../nested-sidebar/nested-sidebar-intropon-poster/nested-sidebar-intropon-poster.component';
import { ComponentsVideoembedComponent } from '../components/components-videoembed/components-videoembed.component';
import { NestedSidebarProductCatalogComponent } from '../nested-sidebar/nested-sidebar-product-catalog/nested-sidebar-product-catalog.component';
import { ToolsChangelangComponent } from '../tools/tools-changelang/tools-changelang.component';
import { NotFoundComponent } from '../website/website-not-found/not-found.component';
import { NestedNavDownloadsComponent } from '../nested-nav-downloads/nested-nav-downloads.component';
import { NestedSidebarEthernetFlyerComponent } from '../nested-sidebar/nested-sidebar-ethernet-flyer/nested-sidebar-ethernet-flyer.component';
import { ComponentVideoembedThumbnailComponent } from '../components/component-videoembed-thumbnail/component-videoembed-thumbnail.component';
import { ComponentsEolComponent } from '../components/components-eol/components-eol.component';
const baseUrl = window.location.origin + '/';

@NgModule({
  declarations: [
    CompanyHowtobuyNestedComponent,
    NestedWarningSoftwareDowngradeComponent,
    NestedWarningSoftwareUpgradeRxt1200Component,
    NestedWarningSoftwareUpgradeRxt4500Component,
    NestedServerVesionComponent,
    NestedServerVesionImageComponent,
    NestedNavRelatedproductsComponent,
    SafePipe,
    NestedSupportNavComponent,
    NestedPrivacyPolicyComponent,
    NestedTermsOfUseComponent,
    ComponentVxCardComponent,
    ComponentLineClampComponent,
    NestedSidebarIntrocwdmDwdmOptnetPosterComponent,
    NestedSidebarSyncptpPosterComponent,
    NestedSidebarIntroponPosterComponent,
    ComponentsVideoembedComponent,
    NestedSidebarProductCatalogComponent,
    ToolsChangelangComponent,
    NotFoundComponent,
    NestedNavDownloadsComponent,
    NestedSidebarEthernetFlyerComponent,
    ComponentVideoembedThumbnailComponent,
    ComponentsEolComponent
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild({
      extend: true
  }),
    // TranslateModule,
    NgOptimizedImage,
    FormsModule,
    RouterModule
  ],
  exports: [
    CommonModule,
    CompanyHowtobuyNestedComponent,
    NestedWarningSoftwareDowngradeComponent,
    NestedWarningSoftwareUpgradeRxt1200Component,
    NestedWarningSoftwareUpgradeRxt4500Component,
    NestedServerVesionComponent,
    NestedServerVesionImageComponent,
    NestedNavRelatedproductsComponent,
    SafePipe,
    NgOptimizedImage,
    FormsModule,
    RouterModule,
    TranslateModule,
    NestedSupportNavComponent,
    NestedPrivacyPolicyComponent,
    NestedTermsOfUseComponent,
    ComponentVxCardComponent,
    ComponentLineClampComponent,
    NestedSidebarIntrocwdmDwdmOptnetPosterComponent,
    NestedSidebarSyncptpPosterComponent,
    NestedSidebarIntroponPosterComponent,
    ComponentsVideoembedComponent,
    NestedSidebarProductCatalogComponent,
    ToolsChangelangComponent,
    NotFoundComponent,
    NestedNavDownloadsComponent,
    NestedSidebarEthernetFlyerComponent,
    ComponentVideoembedThumbnailComponent,
    ComponentsEolComponent
  ],
  providers: [provideImgixLoader(baseUrl)]
})
export class SharedModule { }
